import { render, staticRenderFns } from "./PopularAd.vue?vue&type=template&id=6d0d4526&"
import script from "./PopularAd.vue?vue&type=script&lang=js&"
export * from "./PopularAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6d0d4526', component.options)
    } else {
      api.reload('6d0d4526', component.options)
    }
    module.hot.accept("./PopularAd.vue?vue&type=template&id=6d0d4526&", function () {
      api.rerender('6d0d4526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/PopularAd.vue"
export default component.exports